module.exports = __webpack_public_path__ + "img/y17.bce32080.jpg";